<style lang="scss" scoped>
.chat-modal::v-deep .v--modal-box {
  overflow: visible;
}
</style>
<template>
  <div v-if="transaction">
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/transaction"
          :filter="[
            {
              name: 'where',
              attributes: {
                id: this.id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'id',
              name: 'ID',
              type: 'TransactionLinkCell'
            },
            {
              type: 'DateTimeCell',
              attribute: 'paid_at',
              name: 'Datum'
            },
            {
              attribute: 'amount',
              name: 'Einheiten'
            },
            {
              type: 'CurrencyCell',
              attribute: 'price',
              name: 'Preis'
            },
            {
              attribute: 'service_string',
              name: 'Methode'
            },
            {
              attribute: 'service_transaction_id',
              name: 'Buchungs-/Transaktionsnummer'
            },
            {
              type: 'TransactionConfirmCell',
              attribute: 'state',
              name: 'Gebucht?'
            }
          ]"
        >
          <div slot="title">Transaktionen</div>
        </v-table>
      </div>
    </div>
    <resource
      resource="transaction"
      notification="Die Informationen wurden gespeichert"
      :original="transaction[0]"
      colStyle="fill"
      :attributes="[
        {
          name: 'information',
          type: 'TextareaSelector',
          rows: 8
        }
      ]"
    >
      <div slot="title">
        <h4>Informationen</h4>
      </div>
    </resource>
  </div>
</template>

<script>
export default {
  components: {},
  created() {
    this.$store
      .dispatch("transaction/read", {
        filter: [
          {
            name: "where",
            attributes: {
              id: this.id
            }
          }
        ]
      })
      .then(() => {
        this.information = this.transaction[0].information;
      });
  },
  data() {
    return {
      information: ""
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    transaction() {
      return this.$store.getters["transaction/transaction"](this.id);
    }
  }
};
</script>
